export const strings = {
  cases: 'Cases',
  journals: 'Journals',
  comments: 'Comments',
  pending: 'Pending',
  approved: 'Approved',
  rejected: 'Rejected',
};
